// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"6aa99c51","796":"49e9ce0a"}[chunkId] + ".chunk.js";
};